// import "css!nmodule/hesStationHealth/ext/fontawesome/css/all.min";
import {Container, Row, Col, Card} from "react-bootstrap";
import Gauge from "./Gauge";
import SparkChart from "./SparkChart";
import React from "react";



function ServiceOverallHealthKpi({data}) {

    function precise(x, precision) {
        // @ts-ignore
        return Number.parseFloat(x).toFixed(precision);
        //return Number.parseFloat(x).toPrecision(4);
    }

    function separate(x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    function lessThan(x, y) {
        if (x < y) {
            return true;
        } else {
            return false;
        }
    }

    function greaterThan(x, y) {
        if (x > y) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <>


            <Card bg="light" className="m-2 overflow-hidden" style={{ height: '24rem' }}>
                <Card.Title className="fw-bold px-2 pt-1 mb-0 fs-3 text-center dash-title">
                    Average Meter Health KPI
                </Card.Title>
                <Card.Body>
                    <Container>
                        <Row>
                            <Col sm={8}>
                                <Gauge _value={data.kpi} config={{
                                                                     width: 200,
                                                                     height: 170,
                                                                     inRad: 65,
                                                                     outRad: 80,
                                                                     cornRad: 14,
                                                                     arcLength: 230,
                                                                     bgFill: "#e9ecef",
                                                                     fgFill: "#198754",
                                                                     textSize: 32,
                                                                     textWeight: 600,
                                                                     threshold1: 75,
                                                                     thresholdFill1: "#dc3545",
                                                                     threshold2: 85,
                                                                     thresholdFill2: "#ffc107",
                                                                     delay: 500,
                                                                     duration: 1000,
                                                                   }}
                                                           ></Gauge>
                            </Col>
                            <Col sm={4} className="d-flex fs-4">
                                <div
                                    className={
                                        `${lessThan(data.kpiChange, 0) ? " text-danger" : ""}` +
                                        `${greaterThan(data.kpiChange, 0) ? " text-success" : ""}` +
                                        " text-center align-self-end mb-2 text-nowrap"
                                    }>

                                    <i className={
                                        `${lessThan(data.kpiChange, 0) ? "fa fa-arrow-down" : ""}` +
                                        `${greaterThan(data.kpiChange, 0)? "fa fa-arrow-up" : ""}` +
                                        " fa-fw  mx-1"}></i>
                                    {Math.abs(precise(data.kpiChange, 1)) + "%"}

                                </div>

                            </Col>
                        </Row>
                    </Container>
                </Card.Body>
                <Card.Footer className="p-0 overflow-hidden">
                    <SparkChart data={data.spark}></SparkChart>
                </Card.Footer>
            </Card>


        </>
    );
}

export default ServiceOverallHealthKpi;
